import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { Programs } from './pages/Programs';
import { ProgramDetail } from './pages/ProgramDetail';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { HowItWorks } from './pages/HowItWorks';
import { Labs } from './pages/Labs';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { GetStarted } from './pages/GetStarted';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31cjjro54x0vk">
      <ScrollToTop data-id="element-1" data-mp="2wjgqlh49rtfw" />
      <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-2" data-mp="2wiyx2s8zrtbo">
        <Header data-id="element-3" data-mp="28u5yeo0zj7dd" />
        <Routes data-id="element-4" data-mp="28tmex2vosax8">
          <Route path="/" element={<Home data-id="element-6" data-mp="28sl4n0mhvsgk" />} data-id="element-5" data-mp="28te3zgj4jfoo" />
          <Route path="/programs" element={<Programs data-id="element-8" data-mp="23w4fq47h1a2f" />} data-id="element-7" data-mp="28s2z1ddy01vz" />
          <Route path="/programs/:slug" element={<ProgramDetail data-id="element-10" data-mp="23ti6m04xmmi3" />} data-id="element-9" data-mp="23ujl6el5pr4k" />
          <Route path="/shop" element={<Shop data-id="element-12" data-mp="3ij65gd4jrr9g" />} data-id="element-11" data-mp="3ikh5c1uvgeva" />
          <Route path="/shop/:slug" element={<ProductDetail data-id="element-14" data-mp="3mlayb9n68jv1" />} data-id="element-13" data-mp="3ihv1odb3qjic" />
          <Route path="/how-it-works" element={<HowItWorks data-id="element-16" data-mp="3mjg8bgx1m1k3" />} data-id="element-15" data-mp="3mkhnnxl3da7m" />
          <Route path="/labs" element={<Labs data-id="element-18" data-mp="3rdapodp6e4g0" />} data-id="element-17" data-mp="3rcj6k2crlz6m" />
          <Route path="/pricing" element={<Pricing data-id="element-20" data-mp="3relvsk63foaa" />} data-id="element-19" data-mp="3rcswjpxt86cb" />
          <Route path="/about" element={<About data-id="element-22" data-mp="4n5i12o8na1" />} data-id="element-21" data-mp="6hr7hlrojf6" />
          <Route path="/get-started" element={<GetStarted data-id="element-24" data-mp="2zld0746gb58w" />} data-id="element-23" data-mp="56lhc8rh1lf" />
          <Route path="*" element={<Home data-id="element-26" data-mp="2zmo5x9jgin2n" />} data-id="element-25" data-mp="2zm4ywnvchj3e" />
        </Routes>
        <Footer data-id="element-27" data-mp="33mowttnqsqql" />
      </div>
    </BrowserRouter>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}